import React from "react";
import { useSelector } from "react-redux";
import { removeItem, resetCart } from "../../redux/cartReducer";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from "../../context/AuthContext";
import { message } from "antd";

const Cart = () => {
  const navigate = useNavigate();
  const uplURL = process.env.REACT_APP_UPLOAD_URL;
  const products = useSelector((state) => state.cart.products);
  const dispatch = useDispatch();
  const { user } = useAuthContext();

  const totalPrice = () => {
    let total = 0;
    products.forEach((item) => {
      total += item.quantity * item.price;
    });
    return total.toFixed(2);
  };
  const gotoCheckout = async () => {
    if (user) {
      navigate("/checkout", { replace: true });
    } else {
      navigate("/signin?ref=checkout", { replace: true });
    }
    /*try {
      const res = await makeRequest.post("/orders", {
        products,
      });
      
    } catch (err) {
      console.log(err);
    }*/
  };
  return (
    <div className="container py-5">
      <div className="row">
        <h1>Products in your cart</h1>
        {products?.map((item) => (
          <div className="col-md-3 mt-3" key={item.id}>
            <div className="card mb-4 product-wap rounded-0">
              <div className="card rounded-0">
                <span className="newMark bg-dark"><i className="fas fa-trash" 
                  onClick={() => dispatch(removeItem(item.id))}></i></span>
                <img className="card-img" src={process.env.REACT_APP_UPLOAD_URL + item.img} alt="" />
                <div className="card-body">
                  <h4>{item.title}</h4>
                  <p className="text-center mb-0">
                    {item.quantity} x ₹{item.price}
                  </p>
                  {item.file !== "" ? (
                    <p>Personal Image<br/><img src={uplURL + item.file} className="img-thumbnail me-3 mb-3" /></p>
                  ) : ""}
                  {item.message !== "" ? (
                    <p>Personal Message<br/>
                      <span className="text-muted">{item.message}</span>
                    </p>
                  ) : ""}
                </div>
              </div>
            </div>
          </div>
        ))}
        {(products.length > 0) ? 
        <>
          <div className="row mb-4">
            <div className="col-lg-6"><p className="text-end">SUBTOTAL : </p></div>
            <div className="col-lg-6"><p className="text-end">₹{totalPrice()}</p></div>
          </div>
          <div className="col d-grid"><button className="btn btn-success btn-lg card-proceed-btn" onClick={gotoCheckout}>PROCEED TO CHECKOUT</button></div>
          <div className="text-center mt-2">
            <span className="reset" onClick={() => dispatch(resetCart())}>
              Reset Cart
            </span>
          </div>
        </> : <div className="text-center h3 p-5"> Your Cart is Empty! Add some nice products</div>}
      </div>
    </div>
  );
};

export default Cart;
